import { SidenavService } from 'src/app/services/sidenav.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FaqService } from 'src/app/services/faq.service';
import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  OnChanges,
} from '@angular/core';
import { AppStateProvider } from 'src/app/services/app-state.provider';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { XssValidationService } from 'src/app/services/xss-validation.service';

@Component({
  standalone: false,
  selector: 'app-add-faq',
  templateUrl: './add-faq.component.html',
  styleUrls: ['./add-faq.component.scss'],
})
export class AddFaqComponent implements OnInit, OnChanges {
  @ViewChild('content', { static: false }) contents: ElementRef;
  meetingNav: { index: string; name: string; link: string }[];
  question: string = '';
  answer: string = '';
  isEdit: boolean = false;
  id: any;
  pageText: any = 'Add';
  errorText: string = '';
  error = [];
  content: any[] = [
    {
      question: '',
      answer: '',
      faqId: '',
    },
  ];

  public faqs: any[] = [
    {
      question: '',
      answer: '',
      faqId: '',
    },
  ];
  closeResult: string;
  isPopup: boolean = false;
  private subscriptions = new Subscription();

  ngOnChanges() {
    console.log(this.isPopup);
  }

  constructor(
    private apiService: FaqService,
    private appStateSrv: AppStateProvider,
    private router: Router,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private sideNavService: SidenavService,
    private xssValidation: XssValidationService,
  ) {
    this.id = this.route.snapshot.params.id;
    localStorage.setItem('questionEntered', 'false');
  }

  open(content) {
    this.modalService
      .open(content, {
        ariaLabelledBy: 'modal-basic-title',
        centered: true,
        windowClass: 'custom-class',
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  ngOnInit(): void {
    localStorage.setItem('isFaqSaved', 'false');
    this.subscriptions.add(this.apiService.getPopupStatus().subscribe((status) => {
      console.log('status', status);

      this.isPopup = status;
      if (status) {
        this.open(this.contents);
      }
    }));

    this.pageText = this.id ? 'Edit' : 'Add';

    if (this.id) {
      this.apiService.getFaqByid(this.id).subscribe((res) => {
        this.faqs[0].question = res.question;
        this.faqs[0].answer = res.answer;
        this.faqs[0].id = res.id;
      });
    }
    const customUrl=(this.id)?`edit-faq/${this.id}`:`add-faq`
    const route = this.sideNavService.routingChunks({name: 'FAQs', customUrl:customUrl});

    this.appStateSrv.setSideNavState(route);
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();

    this.answer = ' ';
    this.question = ' ';
    this.id = ' ';
  }

  displayPopup() {
    // this.contents.close('Save click')
    // this.getDismissReason(close);
    this.apiService.triggerPopup(false);
    localStorage.setItem('isFaqSaved', 'true');
    localStorage.setItem('questionEntered','false')
    let nextUrl = localStorage.getItem('faqRedirectRoute');
    console.log(nextUrl);
    this.router.navigate([nextUrl]);
  }

  check(event) {
    console.log(event.target.value)
    if (event.target.value !== '' || event.target.value !== undefined) {
      localStorage.setItem('questionEntered', 'true');
    } else {
      localStorage.removeItem('questionEntered');
    }
  }

  addFaq() {
    this.faqs.push({
      question: '',
      answer: '',
      faqId: '',
    });
  }

  save(type) {
    this.errorText = '';
    this.faqs.forEach((res, i) => {
      console.log(res);
      if (res.question == undefined || res.question.length == 0) {
        console.log('ds', i);
        this.error[res.question + i] = true;
        this.errorText = '*All fields are mandatory';
      }
      if (this.xssValidation.containsScriptTag(res.question)) {
        console.log('ds', i);
        this.error[res.question + i] = true;
        this.errorText = '*Invalid text';
      }
      if (res.answer == undefined || res.answer.length == 0) {
        console.log('ds', i);
        this.error[res.answer + i] = true;
        this.errorText = '*All fields are mandatory';
      }
      if (this.xssValidation.containsScriptTag(res.answer)) {
        console.log('ds', i);
        this.error[res.answer + i] = true;
        this.errorText = '*Invalid text';
      }
    });

    if (this.errorText) {
      return;
    } else {
      let data;
      let param = this.id != undefined ? '?id=' + this.id : '';

      if (this.id != undefined) {
        data = [
          {
            question: this.faqs[0].question,
            answer: this.faqs[0].answer,
            faqId: this.id,
          },
        ];
      } else {
        data = this.faqs;
      }

      console.log('data', data);
      this.subscriptions.add(this.apiService.saveFaq(data, param).subscribe((res) => {
        if (res.isValid) {
          localStorage.setItem('isFaqSaved', 'true');
          this.router.navigate(['/faq']);
        }
      }))
    }
  }
}
